import { index } from "./components/index";
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { tab } from "./components/tab";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { throttle } from 'throttle-debounce'

gsap.registerPlugin(ScrollTrigger);


const hamburger = document.querySelector('.l-hamburger');
const drawer = document.querySelector('.l-drawer');

hamburger.addEventListener('click', () => {
	hamburger.classList.toggle('_active');
	drawer.classList.toggle('_active');
})

if (document.querySelector('.p-home')) {
	index();
}

if (document.querySelector('.p-business__container')) {
	tab(".tabs", ".p-business__content");

	/*
		gsap.utils.toArray('.p-business__specialized .photo li').forEach((box, index) => {
			const updatebgtl = gsap.timeline({

				scrollTrigger: {
					trigger: box,
					scrub: true,
					start: 'top bottom-=' + index * 50,
					endTrigger: ".p-business__container",
					end: 'center center',
					toggleClass: { targets: box, className: "_active" },
					// toggleActions: 'play none none reset',
					// markers: true,
					scrub: 0.2 // smoothing
				}
			})
			updatebgtl.to(box, {
				y: -50 * ((gsap.utils.toArray('.p-business__specialized .photo li').length - index + 1) * 0.5)
			});
		})
		*/
}


if (document.querySelector('.p-hd__products')) {

	var aboutSplide = new Splide('.p-hd__products .splide', {
		type: 'loop',
		drag: false,
		gap: 58,
		// focus: 'center',
		autoWidth: true,
		arrows: true,
		autoplay: true,
		interval: 3000,
		speed: 1000,
		pauseOnFocus: false,
		breakpoints: {
			768: {
				gap: 30,
				autoScroll: {
					speed: 0.5,
					pauseOnHover: false,
				},
			}
		}
	});

	aboutSplide.mount();
}

gsap.utils.toArray('.m-anim__bgtext').forEach((box, index) => {

	box.innerHTML += '　' + box.innerHTML + '　';
	gsap.to(box, {
		x: '-50vw',
		duration: 3,

		scrollTrigger: {
			trigger: box,
			start: 'top bottom',
			end: 'bottom top',
			toggleActions: 'play none none reset',
			// markers: true,
			id: 'box-' + index,
			//scrub: true,
			scrub: 0.5 // smoothing
		}
	})
})


document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener('click', function (e) {
		e.preventDefault(); // デフォルトのリンクの挙動を無効化

		const targetElement = document.querySelector(this.getAttribute('href'));
		const offsetTop = targetElement.offsetTop - document.querySelector('.l-header').clientHeight;

		// スムーススクロール
		window.scrollTo({
			top: offsetTop,
			behavior: 'smooth'
		});
	});
});



document.addEventListener('DOMContentLoaded', () => {
	window.addEventListener(
		'scroll',
		throttle(100, () => {
			getHeader();
		}),
		false
	);
});



const header = document.querySelector('.l-header');
const getHeader = () => {
	const position = window.innerHeight;
	let scrollTop = window.pageYOffset;
	if (scrollTop > position / 2) {
		header.classList.add('_active');
	} else {
		header.classList.remove('_active');
	}
}



var iOSviewportW = 0;
var ua = navigator.userAgent.toLowerCase();
var isiOS = (ua.indexOf("iphone") > -1) || (ua.indexOf("ipod") > -1) || (ua.indexOf("ipad") > -1);
if (isiOS) {
	iOSviewportW = document.documentElement.clientWidth;
}
function updateMetaViewport() {
	var viewportContent;
	var w = window.outerWidth;
	if (isiOS) {
		w = iOSviewportW;
	}
	if (w < 1280 && w > 834) {
		viewportContent = "width=1280px,user-scalable=no,shrink-to-fit=yes";
	} else {
		viewportContent = "width=device-width,user-scalable=no,shrink-to-fit=yes";
	}
	document.querySelector("meta[name='viewport']").setAttribute("content", viewportContent);
	console.log(w);
}
//イベントハンドラ登録
window.addEventListener("resize", updateMetaViewport, false);
window.addEventListener("orientationchange", updateMetaViewport, false);
//初回イベント強制発動
var ev = document.createEvent("UIEvent");
ev.initEvent("resize", true, true)
window.dispatchEvent(ev);
